if (!customElements.get('image-with-text-slider')) {
  customElements.define('image-with-text-slider', class ImageWithTextSlider extends HTMLElement {
    constructor() {
      super();
      this.splide = new Splide(this.querySelector('.splide'), {
        gap: '40px',
        padding: { left: '10px', right: '15%' },
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true,
        mediaQuery: 'min',
        breakpoints: {
          768: {
            padding: { left: '10px', right: '30%' }
          }
        }
      }).mount();

      this.progressBar = this.querySelector('.progress-bar')
      this.progressItems = []
      if (this.progressBar) {
        this.progressBar.querySelectorAll('.progress-item').forEach(item => {
          this.progressItems.push(item)
        })
        this.splide.on('move', this.onSplideMoved.bind(this))
      }
    }

    onSplideMoved (newIndex, prevIndex) {
      for (let i = 0; i < this.progressItems.length; i++) {
        const element = this.progressItems[i]
        if (i <= newIndex) {
          // active
          if (!element.classList.contains('active')) {
            element.classList.add('active')
          }
        } else {
          // inactive
          element.classList.remove('active')
        }
      }
    }
  })
}
